import React, { useEffect } from "react";
import { useParams, withRouter } from "react-router-dom";
import articlesStore from "../../../store/articles/ArticlesStore";
import { Checkbox, CircularProgress, FormControlLabel, Paper } from "@material-ui/core";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import List from "@material-ui/core/List";
import ArticlegroupDraggable from "./ArticlegroupDraggable";
import Button from "@material-ui/core/Button";
import cloudStore from "../../../store/CloudStore";
import Typography from "@material-ui/core/Typography";
import { getArticles, updateArticlegroups, updateArticles } from "../../../store/articles/ArticlesApi";
import { sortOnPriority } from "../../../store/articles/ArticlesHelpers";
import withIntl from "../../../utils/withIntl";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { ExpandLess } from "@material-ui/icons";
import SearchBox from "../SearchBox";
import TranslationSelection from "../../TranslationSelection/TranslationSelection";
import ActionButtonArticlesMenu from "../ActionButtons/ActionButtonArticlesMenu";

const useStyles = makeStyles((theme) => ({
  rootButton: {
    fontSize: 12,
    padding: 2,
  },
  labelFormControlLabel: { paddingRight: 5, fontSize: 12 },
}));

function ArticleMenu(props) {
  const classes = useStyles();
  const merchantId = Number.parseInt(useParams().merchantId);
  const [articlegroups, setArticlegroups] = React.useState(null);
  const articleIdParam = new URLSearchParams(props.location.search).get("articleId");
  const [expandedArticlegroups, setExpandedArticlegroups] = React.useState([]);
  const searchValueParam = new URLSearchParams(props.location.search).get("searchValue");
  const [searchValue, setSearchValue] = React.useState(searchValueParam != null ? searchValueParam : "");
  const [showPosInactiveFilter, setShowPosInactiveFilter] = React.useState(
    localStorage.getItem("article_menu.show_pos_inactive_filter") === "true"
  );
  const [currentLanguage, setCurrentLanguage] = React.useState(cloudStore.merchant.default_language);

  const handleExpansion = (articlegroup_id) => {
    if (expandedArticlegroups.includes(articlegroup_id)) {
      // remove
      const newExpandedArticlegroups = [...expandedArticlegroups];
      newExpandedArticlegroups.splice(
        newExpandedArticlegroups.findIndex((id) => id === articlegroup_id),
        1
      );
      setExpandedArticlegroups(newExpandedArticlegroups);
    } else {
      //add
      const newExpandedArticlegroups = [...expandedArticlegroups, articlegroup_id];
      setExpandedArticlegroups(newExpandedArticlegroups);
    }
  };

  function onChangeArticles() {
    if (articlesStore.articlegroups != null) {
      if (articlegroups == null && articleIdParam != null && articlesStore.articles[articleIdParam] != null) {
        const articlegroupIdToExpand = articlesStore.articles[articleIdParam].articlegroup_id;
        handleExpansion(parseInt(articlegroupIdToExpand));
      }

      setArticlegroups(
        sortOnPriority(
          Object.keys(articlesStore.articlegroups).map(
            (articlegroupKey) => articlesStore.articlegroups[articlegroupKey]
          )
        )
      );
    } else {
      setArticlegroups(null);
    }
  }

  useEffect(() => {
    articlesStore.on(articlesStore.events.MENU_UPDATED, onChangeArticles);
    return () => {
      articlesStore.removeListener(articlesStore.events.MENU_UPDATED, onChangeArticles);
    };
  }, []);

  useEffect(() => {
    if (merchantId !== articlesStore.merchantId) {
      if (articlegroups != null) {
        setArticlegroups(null);
      }
      getArticles(merchantId);
    } else if (articlegroups == null && articlesStore.articlegroups != null) {
      onChangeArticles();
    }
  }, []);

  if (merchantId !== articlesStore.merchantId || !articlegroups) {
    return (
      <div align="center">
        <CircularProgress color="primary" />
      </div>
    );
  }
  if (articlegroups.length === 0) {
    return <div>No articles found</div>;
  }

  const handleExpandAll = () => {
    let newExpanded = [...expandedArticlegroups];
    articlegroups.forEach((articlegroup) => {
      if (!expandedArticlegroups.includes(articlegroup.id)) {
        newExpanded.push(articlegroup.id);
      }
    });
    setExpandedArticlegroups(newExpanded);
  };

  const handleCollapseAll = () => {
    setExpandedArticlegroups([]);
  };

  let filteredArticlegroups = [...articlegroups];

  filteredArticlegroups = filteredArticlegroups.reduce((filtered, articlegroup) => {
    try {
      // articlegroup = { ...articlegroup };

      //new articles created
      if (isNaN(articlegroup.id)) {
        filtered.push(articlegroup);
        return filtered;
      }

      let articlegroupFound = false;
      if (searchValue.length > 0) {
        if (articlegroup.name && articlegroup.name.toLowerCase().includes(searchValue.toLowerCase())) {
          filtered.push(articlegroup);
          articlegroupFound = true;
        }
      }

      let articles = articlegroup.getArticles(articlesStore.articles).filter((article) => {
        if (article.type !== "ARTICLE" && article.type !== "FREETPARTICLE" && article.type !== "SERVICE") {
          article.hide = true;
          return false;
        }

        if (!showPosInactiveFilter && !article.active) {
          article.hide = true;
          return false;
        }

        if (!articlegroupFound && searchValue.length > 0) {
          if (
            (article.description && article.description.toLowerCase().includes(searchValue.toLowerCase())) ||
            (article.name && article.name.toLowerCase().includes(searchValue.toLowerCase())) ||
            article.plu.toLowerCase().includes(searchValue.toLowerCase())
          ) {
            article.hide = false;
            return true;
          } else {
            article.hide = true;
            return false;
          }
        } else {
          article.hide = false;
          return true;
        }
      });

      if (!articlegroupFound && articles.length > 0) {
        filtered.push(articlegroup);
        return filtered;
      } else {
        return filtered;
      }
    } catch (e) {
      return filtered;
    }
  }, []);

  const onDragEnd = (result) => {
    if (!result.destination) {
      return;
    }

    if (result.type === "ARTICLEGROUP") {
      let newArticlegroups = [...filteredArticlegroups];

      const oldIndex = result.source.index;
      const newIndex = result.destination.index;

      newArticlegroups.splice(newIndex, 0, newArticlegroups.splice(oldIndex, 1)[0]);

      for (let i = 0; i < newArticlegroups.length; i++) {
        // newArticlegroups[i] = Object.assign(new Articlegroup(), newArticlegroups[i]);
        newArticlegroups[i].priority = 1000 - i;
      }
      newArticlegroups.sort((a, b) => b.priority - a.priority);

      setArticlegroups(newArticlegroups);
      updateArticlegroups(
        articlesStore.merchantId,
        newArticlegroups,
        "priority",
        newArticlegroups.map((articlegroup) => articlegroup.priority)
      ).catch(() => {
        onChangeArticles();
      });
    } else if (result.type === "ARTICLE") {
      let newArticlegroups = [...filteredArticlegroups];

      const getId = (droppableId) => {
        let splitted = droppableId.split("-");
        splitted = splitted.slice(2, splitted.length);

        let newId = splitted.reduce((id, splittedElement) => {
          id += splittedElement + "-";
          return id;
        }, "");
        newId = newId.substr(0, newId.length - 1);
        return newId;
      };

      const sourceArticlegroupId = getId(result.source.droppableId);
      const destinationArticlegroupId = getId(result.destination.droppableId);

      const oldIndex = result.source.index;

      const newIndex = result.destination.index;

      const sourceArticlegroupIndex = newArticlegroups.findIndex(
        (articlegroup) => articlegroup.id.toString() === sourceArticlegroupId
      );

      const destinationArticlegroupIndex = newArticlegroups.findIndex(
        (articlegroup) => articlegroup.id.toString() === destinationArticlegroupId
      );

      let destinationArticles = newArticlegroups[destinationArticlegroupIndex].getArticles(articlesStore.articles);
      let sourceArticles = destinationArticles;
      if (destinationArticlegroupIndex !== sourceArticlegroupIndex) {
        sourceArticles = newArticlegroups[sourceArticlegroupIndex].getArticles(articlesStore.articles);
      }

      let targetArticle = sourceArticles.splice(oldIndex, 1)[0];

      destinationArticles.splice(newIndex, 0, targetArticle);

      let newData = [];
      let oldData = [];
      for (let i = 0; i < destinationArticles.length; i++) {
        oldData[i] = {
          priority: destinationArticles[i].priority,
          articlegroup_id: destinationArticles[i].articlegroup_id,
        };
        destinationArticles[i].priority = 1000 - i;
        destinationArticles[i].articlegroup_id = destinationArticlegroupId;
        newData[i] = { priority: 1000 - i, articlegroup_id: destinationArticles[i].articlegroup_id };
        if (isNaN(destinationArticlegroupId)) {
          newData[i]["articlegroup_priority"] = articlesStore.articlegroups[destinationArticlegroupId].priority;
          newData[i]["articlegroup_name"] = articlesStore.articlegroups[destinationArticlegroupId].name;
        }
      }

      if (destinationArticlegroupIndex !== sourceArticlegroupIndex) {
        newArticlegroups[sourceArticlegroupIndex].articleIds = newArticlegroups[
          sourceArticlegroupIndex
        ].articleIds.filter((articleId) => articleId !== targetArticle.id);
        newArticlegroups[destinationArticlegroupIndex].articleIds.push(targetArticle.id);
      }
      setArticlegroups(newArticlegroups);
      updateArticles(articlesStore.merchantId, destinationArticles, newData, oldData);
    }
  };

  let merchantName = "";
  const merchant = cloudStore.merchants?.find((merchant) => merchant.merchant_id === merchantId);
  if (merchant) {
    merchantName = merchant.name;
  }

  return (
    <div>
      <Typography gutterBottom variant="h5" style={{ textAlign: "left" }}>
        {props.intl.formatMessage({ id: "articlegroups" })} - {merchantName}
      </Typography>
      <Paper>
        <Grid container alignItems={"center"}>
          <Grid item xs={9} sm={8} md={7} lg={5}>
            <SearchBox
              searchValue={searchValue}
              onChange={(value) => {
                setSearchValue(value);
              }}
            />
          </Grid>
          <Grid item xs={2} sm={2} md={3} lg={1}>
            <ActionButtonArticlesMenu
              handleExpansion={handleExpansion}
              filteredArticlegroups={filteredArticlegroups}
              articlegroups={articlegroups}
            />
          </Grid>
          <Grid item xs={1} sm={2} md={2} lg={1}>
            <TranslationSelection
              currentLanguage={currentLanguage}
              handleClickLanguage={(language) => setCurrentLanguage(language)}
            />
          </Grid>

          <Grid item xs={3} sm={6} md={7} lg={2}>
            <FormControlLabel
              control={
                <Checkbox
                  color={"primary"}
                  checked={showPosInactiveFilter}
                  onChange={(e) => {
                    localStorage.setItem("article_menu.show_pos_inactive_filter", !showPosInactiveFilter);
                    setShowPosInactiveFilter(!showPosInactiveFilter);
                  }}
                />
              }
              label={"Pos inactive"}
              labelPlacement={"end"}
              classes={{ label: classes.labelFormControlLabel }}
            />
          </Grid>

          <Grid item xs={9} sm={6} md={5} lg={3}>
            <Button
              classes={{ root: classes.rootButton }}
              onClick={handleExpandAll}
              style={{ marginRight: "5px" }}
              variant="standard"
              endIcon={<ExpandMoreIcon />}
            >
              {props.intl.formatMessage({ id: "expand_all" })}
            </Button>

            <Button
              endIcon={<ExpandLess />}
              classes={{ root: classes.rootButton }}
              onClick={handleCollapseAll}
              variant="standard"
            >
              {props.intl.formatMessage({ id: "collapse_all" })}
            </Button>
          </Grid>
        </Grid>
        <DragDropContext key={currentLanguage} onDragEnd={onDragEnd}>
          <Droppable type="ARTICLEGROUP" droppableId={"droppable-articlegroups"}>
            {(provided) => (
              <List dense={true} disablePadding innerRef={provided.innerRef} {...provided.droppableProps}>
                {filteredArticlegroups.map((articlegroup, articlegroupIndex) => (
                  <Draggable
                    type="ARTICLEGROUP"
                    draggableId={"draggable-articlegroup-" + articlegroup.id}
                    key={articlegroup.id}
                    index={articlegroupIndex}
                  >
                    {(provided, snapshot) => {
                      return (
                        <ArticlegroupDraggable
                          currentLanguage={currentLanguage}
                          provided={provided}
                          snapshot={snapshot}
                          expandedArticlegroups={expandedArticlegroups}
                          articlegroup={articlegroup}
                          handleExpansion={handleExpansion}
                          hideDragHandles={searchValue.length > 0}
                        />
                      );
                    }}
                  </Draggable>
                ))}
                {provided.placeholder}
              </List>
            )}
          </Droppable>
        </DragDropContext>
      </Paper>
    </div>
  );
}

export default withRouter(withIntl(ArticleMenu));
